import { trackConfig, type IFramework } from '@/framework';
import {
    LayerType,
    type ILayerProps,
    type IVectorLayerProps,
    type TextWritingType,
    type VectorTextInfo,
} from '@/version-types';
import { pushHistory, resolveVectorTextLayout, updateLayer } from '../utils';

export interface IWritingMode {
    /**
     * 设置文字方向
     *
     * @param layerID - 图层 ID
     * @param writingMode - 写入模式
     */
    setWritingMode(layerID: string, writingMode: TextWritingType): ILayerProps | void;
}

export class WritingMode implements IWritingMode {
    constructor(private framework: IFramework) {}

    /**
     * 更新书写方向并通过真实宿主重新解析布局。
     *
     * @param layerID - 目标 Vector Layer ID。
     * @param writingMode - 新书写方向。
     * @returns 更新后的 Vector；输入不适用或值未变化时返回 void。
     */
    setWritingMode(layerID: string, writingMode: TextWritingType) {
        const prevLayer = this.framework.service.flatLayer.getLayer(layerID, true);
        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const prevLayerData = prevLayer.data as IVectorLayerProps;
        const { textInfo } = prevLayerData;

        if (!textInfo || textInfo.writingMode === writingMode) return;

        const nextTextInfo: VectorTextInfo = { ...textInfo, writingMode };
        const nextLayerData: IVectorLayerProps = { ...prevLayerData, textInfo: nextTextInfo };
        const nextLayer = resolveVectorTextLayout(this.framework, { ...prevLayer, data: nextLayerData });

        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.TEXT_LAYER].writingMode);

        return nextLayer;
    }
}
